import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const chevronDown: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13.156-5.687 7.36.109A.53.53 0 0 1 7 .25a.47.47 0 0 1-.344-.14L.86-5.688a.48.48 0 0 1-.156-.36q-.001-.2.156-.36l1.297-1.28a.45.45 0 0 1 .344-.157q.2.002.36.157L7-3.547l4.156-4.14a.45.45 0 0 1 .344-.157q.2.002.36.157l1.296 1.28a.53.53 0 0 1 0 .72m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.703 7.844)"
    />
  ),
  svgProps: {
    height: "8.094",
    width: "12.594",
  }
};

export const chevronRight: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8.656-5.156 2.86.656a.53.53 0 0 1-.359.14.47.47 0 0 1-.344-.14L.86-.656A.44.44 0 0 1 .703-1q-.002-.2.156-.36L5-5.5.86-9.656A.44.44 0 0 1 .702-10q-.001-.2.156-.36l1.297-1.296a.47.47 0 0 1 .344-.14q.2 0 .36.14L8.655-5.86q.14.159.14.359 0 .204-.14.344m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.703 11.797)"
    />
  ),
  svgProps: {
    height: "12.594",
    width: "8.094",
  }
};